import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
     Club,
     SelectedClubService,
} from '../../services/selected-club.service';
import { WsService } from '../../services/ws/ws.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { IS_MOBILE_DEVICE } from '../../constants';
import { IAppConfig } from '../../../typings';

const placeholders = [
     window.appLang[10170] /*Enter a postal code, city or center code*/,
     window.appLang.ENTER_A_POSTAL_CODE,
     window.appLang.ENTER_THE_CITY_NAME,
     window.appLang.ENTER_THE_CENTER_CODE,
];

enum PLACEHOLDER_TYPE {
     DEFAULT = 0,
     POSTAL_CODE = 1,
     CITY = 2,
     CLUB_CODE = 3,
}

@Component({
     selector: 'app-choose-club',
     templateUrl: './choose-club.component.html',
     styleUrls: ['./choose-club.component.scss'],
})
export class ChooseClubComponent implements OnInit {
     @ViewChild('input') input: ElementRef;
     placeholder = placeholders[PLACEHOLDER_TYPE.DEFAULT];
     isMobile = IS_MOBILE_DEVICE;
     clubName = window.app.club.company;
     FILTERS = {
          ALL: 'ALL',
          CITY: 'CITY',
          POSTAL_CODE: 'POSTAL_CODE',
          CLUB_CODE: 'CLUB_CODE',
     };
     appCfg: IAppConfig = window.app;
     currentFilter;
     clubs$: Observable<Club[]>;
     club: Club;

     constructor(
          private ws: WsService,
          private selectedClub: SelectedClubService,
          private router: Router
     ) {
          this.club = this.selectedClub.club;
          this.currentFilter = this.FILTERS.ALL;
     }

     ngOnInit() {
          this.search('');
     }

     handleSubmit($event, searchStr) {
          if ($event) {
               $event.preventDefault();
          }
          this.search(searchStr);
     }

     search(searchStr) {
          searchStr = searchStr ? searchStr.toUpperCase() : null;
          let obj = {} as any;
          if (this.currentFilter === this.FILTERS.ALL) {
               if (searchStr) {
                    obj.q = searchStr ? searchStr.toUpperCase() : null;
               }
          } else if (this.currentFilter === this.FILTERS.CITY) {
               obj.city = searchStr;
          } else if (this.currentFilter === this.FILTERS.CLUB_CODE) {
               obj.obId = searchStr;
          } else if (this.currentFilter === this.FILTERS.POSTAL_CODE) {
               obj.postalCode = searchStr;
          }
          this.clubs$ = this.ws.clubs.browseClub(obj);
     }

     selectClub(c: Club) {
          this.selectedClub.club = c;
          this.router.navigateByUrl('/');
     }

     setFilter(filter) {
          if (filter === this.FILTERS.ALL) {
               this.placeholder = placeholders[PLACEHOLDER_TYPE.DEFAULT];
          } else if (filter === this.FILTERS.CITY) {
               this.placeholder = placeholders[PLACEHOLDER_TYPE.CITY];
          } else if (filter === this.FILTERS.CLUB_CODE) {
               this.placeholder = placeholders[PLACEHOLDER_TYPE.CLUB_CODE];
          } else if (filter === this.FILTERS.POSTAL_CODE) {
               this.placeholder = placeholders[PLACEHOLDER_TYPE.POSTAL_CODE];
          }
          this.currentFilter = filter;

          let value = this.input.nativeElement.value;
          if (value) {
               this.search(value);
          }
     }

     handleMockPaymentChange() {
          return () => {
               let value = this.input.nativeElement.value;
               this.search(value);
          };
     }
}
